import React, { useEffect, useState } from "react";
import styles from "./Notifications.module.css";
import { Box, SubmitButton, TextComponent } from "../../../components";
import AvatarOne from "../../../assets/avatar-1.png";
import AvatarTwo from "../../../assets/avatar-2.png";
import AvatarThree from "../../../assets/avatar-3.png";
import AvatarFour from "../../../assets/avatar-4.png";
import AvatarFive from "../../../assets/staticImages/engagementAvatar.png";
import { Carousel, Col, List, Row } from "antd";
import { BsDot } from "react-icons/bs";
import image from "../../../assets/staticImages/photoimg3.png";
import image2 from "../../../assets/staticImages/photographar.png";
import { roles } from "../../../config/roles";
import Storage from "../../../utills/AsyncStorage";
import { NotificationMiddleware } from "../../../Store/Middlewares/NotificationMiddleware";
import { AuthMiddleware } from "../../../Store/Middlewares/AuthMiddleware";
import { useDispatch, useSelector } from "react-redux";
import dummyImg from "../../../assets/imageplace.jpg";
import dummyImg1 from "../../../assets/dummy.jpg";
const Notifications = () => {
  const role = Storage.getERole("@role");
  const dispatch = useDispatch();
  const [ads, setAds] = useState([]);
  const AllNotification = useSelector(
    (state) => state?.NotificationReducer?.notifications
  );
  console.log("AllNotification", AllNotification);
  console.log("ads", ads);
  const getNotification = (temp) => {
    dispatch(NotificationMiddleware.getNotification(temp));
  };
  useEffect(() => {
    getNotification();
    dispatch(AuthMiddleware.getAds())
      .then((res) => {
        setAds(res);
      })
      .catch((err) => {
        console.log("err", err);
      });
  }, []);

  const onSeeMorePress = () => {
    const temp = {
      data: AllNotification?.data,
      nextPage: AllNotification?.links?.next,
    };
    getNotification(temp);
  };
  const notificationData = [
    {
      id: 1,
      img: AvatarOne,
      title: "Kenneth Allen",
      desc: '"Hi [User], just a friendly reminder that your wedding dress fitting appointment is scheduled for tomorrow at 3:00 PM.',
      active: true,
    },
    {
      id: 2,
      img: AvatarTwo,
      title: "Kurt Bates",
      desc: "Great news! Your preferred photographer, [Vendor Name], is available on your wedding day.",
      active: false,
    },
    role === roles.guest && {
      id: 11,
      img: AvatarFive,
      title: "Engagement Ceremony",
      desc: "Event Started! Join Now.. ",
      active: true,
      event: true,
    },
    {
      id: 3,
      img: AvatarThree,
      title: "David Elson",
      desc: "Hello [User], you've reached 80% of your allocated budget. Take a moment to review your expenses",
      active: true,
    },
    {
      id: 4,
      img: AvatarFour,
      title: "Rodger Struck",
      desc: "Looking for a talented florist? Check out our recommended vendor",
      active: false,
    },
    {
      id: 5,
      img: AvatarOne,
      title: "Kenneth Allen",
      desc: '"Hi [User], just a friendly reminder that your wedding dress fitting appointment is scheduled for tomorrow at 3:00 PM.',
      active: true,
    },
    {
      id: 6,
      img: AvatarTwo,
      title: "Kurt Bates",
      desc: "Great news! Your preferred photographer, [Vendor Name], is available on your wedding day.",
      active: false,
    },
    {
      id: 7,
      img: AvatarThree,
      title: "David Elson",
      desc: "Hello [User], you've reached 80% of your allocated budget. Take a moment to review your expenses",
      active: true,
    },
    {
      id: 8,
      img: AvatarFour,
      title: "Rodger Struck",
      desc: "Looking for a talented florist? Check out our recommended vendor",
      active: false,
    },
    {
      id: 9,
      img: AvatarTwo,
      title: "Kurt Bates",
      desc: "Great news! Your preferred photographer, [Vendor Name], is available on your wedding day.",
      active: false,
    },
    {
      id: 10,
      img: AvatarThree,
      title: "David Elson",
      desc: "Hello [User], you've reached 80% of your allocated budget. Take a moment to review your expenses",
      active: true,
    },
    {
      id: 11,
      img: AvatarFour,
      title: "Rodger Struck",
      desc: "Looking for a talented florist? Check out our recommended vendor",
      active: false,
    },
  ];
  const notificationVendor = [
    {
      id: 1,
      img: AvatarOne,
      title: "Kenneth Allen",
      desc: "Get ready for your upcoming event!",
      active: true,
    },
    {
      id: 2,
      img: AvatarTwo,
      title: "Kurt Bates",
      desc: "Update your profile for better visibility.",
      active: false,
    },
    {
      id: 3,
      img: AvatarThree,
      title: "David Elson",
      desc: "Stay informed with important updates.",
      active: true,
    },
    {
      id: 4,
      img: AvatarFour,
      title: "Rodger Struck",
      desc: "Stay in the loop with our latest news and updates.",
      active: false,
    },
    {
      id: 5,
      img: AvatarOne,
      title: "Kenneth Allen",
      desc: "Stay in the loop with our latest news and updates.",
      active: true,
    },
  ];

  const advData = [
    {
      id: 1,
      image: image,
      role: "Photgrapher",
      name: "David Elson",
      desc: "Photography services now available",
      price: "$25",
      eventOffer: [
        {
          id: 1,
          text: "Bridal Potraits",
        },
        {
          id: 2,
          text: "Candidate Moments",
        },
        {
          id: 3,
          text: "Reception Coverage",
        },
      ],
    },
    {
      id: 1,
      image: image2,
      role: "Caterar",
      name: "Henry Ella",
      desc: "Catering services now available",
      price: "$50",
      eventOffer: [
        {
          id: 1,
          text: "Bridal Potraits",
        },
        {
          id: 2,
          text: "Candidate Moments",
        },
        {
          id: 3,
          text: "Reception Coverage",
        },
      ],
    },
  ];

  const notificationItem = (item) => {
    return (
      <div
        className={
          item?.active ? styles.notificationItem : styles.nonActiveNotItem
        }
      >
        <div className={styles.notificationItemContainer}>
          <div className={styles.notificationIcon}>
            <img
              src={item?.image ? item?.image : dummyImg1}
              alt="Notification Icon"
            />
          </div>
          <div className={styles.notificationContent}>
            <TextComponent
              text={item?.title}
              textClass={styles.notificationTitle}
            />
            <TextComponent
              textClass={styles.notificationDesc}
              text={item?.body}
            />
          </div>
        </div>
        <div className={styles.notificationRightCol}>
          {item?.type == "Stream" ? (
            <SubmitButton title="Join Stream" btnClass={styles.streamBtn} />
          ) : null}
          {/* {role === roles.guest && item?.event && (
              <SubmitButton title="Join Stream" btnClass={styles.streamBtn} />
            )} */}
          <BsDot className={styles.activeFontSize} color="#34B440" />
        </div>
        {/* {item?.active ? (
          <div className={styles.notificationRightCol}>
            {role === roles.guest && item?.event && (
              <SubmitButton title="Join Stream" btnClass={styles.streamBtn} />
            )}
            <BsDot className={styles.activeFontSize} color="#34B440" />
          </div>
        ) : null} */}
      </div>
    );
  };
  return (
    <>
      <div
        className={styles.notificationContainer}
        style={{ height: role !== roles.client && "90vh" }}
      >
        <List
          className={styles.list}
          itemLayout="vertical"
          dataSource={
            // role == roles.vendor ? notificationVendor : 
            AllNotification?.data
          }
          renderItem={notificationItem}
          footer={
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {AllNotification?.links?.next != null ? (
                <div style={{ width: "50%" }}>
                  <SubmitButton
                    title={"Load More"}
                    onClick={onSeeMorePress}
                  />
                </div>
              ) : null}
            </div>
          }
        />
      </div>
      {role === roles.client && (
        <Carousel
          dots={{ className: styles.dotsClass }}
          dotPosition="top"
          autoplay
          className={"carousel"}
        >
          {ads.map((item, index) => {
            return (
              <div className={styles.listItem} key={index}>
                <div className={styles.imgDiv}>
                  <img src={item?.image ? item?.image : dummyImg} />
                </div>
                <div className={styles.contentDiv}>
                  <div className={styles.content}>
                    <div className={styles.contentLeft}>
                      <TextComponent
                        textClass={styles.roleTxt}
                        text={item?.title}
                      />
                      <TextComponent
                        textClass={styles.descTxt}
                        text={item?.text}
                      />
                      <TextComponent
                        textClass={styles.nameTxt}
                        text={"Available"}
                      />
                    </div>
                    {/* <div className={styles.contentRight}>
                      <div className={styles.CR_left}>
                        <TextComponent text={item?.price} />
                      </div>
                      <div className={styles.CR_right}>
                        <TextComponent
                          textClass={styles.roleTxt}
                          text={"Bridal Portraits"}
                        />
                        <TextComponent
                          textClass={styles.roleTxt}
                          text={"Candid Moments"}
                        />
                        <TextComponent
                          textClass={styles.roleTxt}
                          text={"Reception Coverage"}
                        />
                      </div>
                    </div> */}
                  </div>
                </div>
              </div>
            );
          })}
        </Carousel>
      )}
    </>
  );
};

export default Notifications;
